(ns storrito.date.format
  (:require [cljs-time.format :as tf]
            [cljs-time.coerce :as tc]
            [cljs-time.core :as t]))

;; Concept:

;; The date formatting should be consistent accross the app. Therefore
;; this namespace defines the date formats which should be used. A
;; datetime is a date where the time portion should be displayed.

(def standard-datetime-formatter
  (tf/formatter
   "yyyy-MM-dd HH:mm:ss"))

(def short-datetime-formatter
  (tf/formatter "dd.MM HH:mm"))

(def date-formatter (tf/formatter "EEE, yyyy-MM-dd"))

(def date-formatter-detailed (tf/formatter "EEEE, do MMMM yyyy"))

(def date-formatter-short (tf/formatter "EEE, dd MMM yyyy"))

(def date-time-formatter (tf/formatter "EEE, dd MMM yyyy HH:mm"))

(def time-formatter (tf/formatter "HH:mm"))

(def iso-date-formatter
  (tf/formatter "yyyy-MM-dd"))

(defn format [formatter js-date]
  (some->> js-date
           (tc/to-date-time)
           (t/to-default-time-zone)
           (tf/unparse-local formatter)))

(defn parse-date
  [formatter date-str]
  (some->> date-str
           (tf/parse-local-date formatter)
           (tc/to-date)))

(defn format-standard-datetime
  "Standard datetime format for this app (uses local timezone)."
  [js-date]
  (format standard-datetime-formatter js-date))

(defn begin-of-month
  "Returns the begin of the month of the given `date`."
  [date]
  (let [datetime (tc/to-date-time date)]
    (t/date-time (t/year datetime)
                 (t/month datetime))))
